import { render, staticRenderFns } from "./entity-card.vue?vue&type=template&id=ceaf4174&scoped=true&"
import script from "./entity-card.ts?vue&type=script&lang=ts&"
export * from "./entity-card.ts?vue&type=script&lang=ts&"
import style0 from "./entity-card.scss?vue&type=style&index=0&id=ceaf4174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaf4174",
  null
  
)

export default component.exports